export function validateRegex(regex, text) {
  if (text == null) return false;
  if (typeof text === 'string' && text.trim() === '') return false;

  const pattern = getValidRegexPattern(regex);

  if (!pattern) return false;

  return pattern.test(text);
}

export function getValidRegexPattern(input) {
  try {
    if (input instanceof RegExp) {
      if (typeof input.source === 'string' && input.source.trim() !== '') {
        return input;
      }
      return '';
    }

    if (typeof input === 'string') {
      const trimmed = input.trim();
      if (trimmed === '') return '';

      const match = trimmed.match(/^\/(.*)\/([gimsuy]*)$/);
      if (match) {
        const patternPart = match[1];
        const flagsPart = match[2] || '';
        if (patternPart.trim() === '') return '';
        return new RegExp(patternPart, flagsPart);
      }

      const r = new RegExp(trimmed);
      if (r.source.trim() === '') return '';
      return r;
    }

    const r = new RegExp(String(input));
    if (r.source.trim() === '') return '';
    return r;
  } catch {
    return '';
  }
}